import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './styles/CookieBanner.css'

const COOKIE_KEY = "cookieAccepted";
const COOKIE_DAYS = 100;

function CookieBanner() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem(COOKIE_KEY);

        if (!accepted) {
            setShow(true);
            return;
        }

        const expires = Number(accepted);

        if (Date.now() > expires) {
            localStorage.removeItem(COOKIE_KEY);
            setShow(true);
        }
    }, []);

    const acceptCookies = () => {
        const expires =
            Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000;

        localStorage.setItem(COOKIE_KEY, expires.toString());
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="cookie-banner">
            <span>
                We use cookies to improve your experience. By continuing to use
                this website, you agree to our use of cookies. Read our{" "}
                <Link to="/cookie-policy">Cookie Policy</Link>.
            </span>

            <button onClick={acceptCookies}>
                Accept
            </button>
        </div>
    );
}

export default CookieBanner;
